import * as Yup from 'yup';
import { createSortSchema } from '@emfood/shared';

export const BUYER_DETAILS_TABS = [
  'address',
  'contact',
  'sites',
  'logo',
  'invoice-ingestion-settings',
] as const;
export type BuyerDetailsTab = (typeof BUYER_DETAILS_TABS)[number];

export const BuyerDetailsSearchParamsSchema = Yup.object({
  tab: Yup.mixed<BuyerDetailsTab>()
    .oneOf([...BUYER_DETAILS_TABS])
    .optional()
    .default('address'),
}).concat(createSortSchema(['name', 'town', 'county'] as const));
